import z from "zod/v4";
export const sortingSchema = z.tuple([z.enum(["price", "name"]), z.enum(["asc", "desc"])]);
export type SortingSchema = z.infer<typeof sortingSchema>;
